module.exports = __webpack_public_path__ + "static/img/color.ccea5717.jpg";